module.exports = __webpack_public_path__ + "img/no-preview.1b61dafa.png";